var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium svg-inline--fa css-vubbuv",
    focusable: "false",
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 448 512",
    "data-prefix": "far",
    "data-icon": "angles-right",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.1 115.1L359.8 252l-121.6 136c-4.094 4.563-6.125 10.28-6.125 16c0 6.594 2.687 13.16 7.1 17.88c9.874 8.844 25.06 8 33.87-1.875l135.1-152c8.187-9.125 8.187-22.88 0-32l-135.1-152c-8.812-9.875-23.1-10.72-33.87-1.875C230.1 90.93 229.3 106.2 238.1 115.1zM217.9 268c8.187-9.125 8.187-22.88 0-32L81.88 83.99C73.07 74.12 57.88 73.28 48 82.12C38.1 90.93 37.29 106.2 46.13 115.1L167.8 252l-121.6 136c-4.094 4.563-6.125 10.28-6.125 16c0 6.594 2.687 13.16 7.1 17.88c9.874 8.844 25.06 8 33.87-1.875L217.9 268z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsed);
export default __webpack_public_path__ + "static/media/collapsed.2f5e86094893507a5857f1f732209034.svg";
export { ForwardRef as ReactComponent };